import { getInFilterValue } from '../utils';
import { BaseHelper } from './BaseGraphQLAPIHelper';

const STAMP_RECORDS_NODE = `{
  id
  pk
  creationDate
  triggerTime
  remark
  recordType
  eventType
  owner {
      id
      pk
      membershipId
      firstName
      lastName
      nickname
      isReset
      mobilePhoneNumberCountryCode
      mobilePhoneNumberSubscriberNumber
      emailAddress
  }
  campaign{
      id
      pk
      name
  }
  transaction {
    pk
    transactionType
    posInvoiceId
    invoiceId
    totalValue
    paidAmount
    date
  }
  reachLimit
  reachLimitInfo
  stampQuantity
  administrator {
    pk
    username
  }
}`;

export const getStampRecords = (afterCursor, payload = {}) => {
  let searchString = payload?.isAll ? '' : `first: ${payload?.pageSize || 20}`;
  if (afterCursor) {
    searchString += `, after: "${afterCursor}"`;
  }
  if (payload?.sort) {
    searchString += `, orderBy: "${payload.sort}"`;
  } else {
    searchString += `, orderBy: "-pk"`;
  }
  if (payload?.event_type) {
    searchString += `, eventTypeIn: ${getInFilterValue(payload.event_type)}`;
  }
  if (payload?.record_type) {
    searchString += `, recordTypeIn: ${getInFilterValue(payload.record_type)}`;
  }
  if (payload?.creation_date) {
    const creationDate = payload.creation_date.split(',');
    searchString += `, creationDateGte: "${creationDate[0]}", creationDateLte: "${creationDate[1]}"`;
  }
  if (payload?.purchase_date) {
    const purchaseDate = payload.purchase_date.split(',');
    searchString += `, purchaseDateGte: "${purchaseDate[0]}", purchaseDateLte: "${purchaseDate[1]}"`;
  }
  if(payload?.searchKey){
    searchString += `, name:"${payload.searchKey}"`
  }
  if (payload?.quantity) {
    const quantity = payload.quantity.split(',');
    searchString += `, stampQuantityGte: ${quantity[0]}, stampQuantityLte: ${quantity[1]}`;
  }
  if (payload?.record_scope === "REWARDED_RECORDS") {
    searchString += `, isEmptyReward: false`;
  } else if (payload?.record_scope === "NON_REWARDED_RECORDS") {
    searchString += `, isEmptyReward: true`;
  }
  if (payload?.campaigns) {
    searchString += `, targetCampaignIds: ${getInFilterValue(payload.campaigns)}`;
  }
  if (payload?.earning_rules) {
    searchString += `, targetEarningRuleIds: ${getInFilterValue(payload.earning_rules)}`;
  }
  if (payload?.transaction) {
    searchString += `, transactionId: ${getInFilterValue(payload.transaction)}`;
  }
  const query = `{
    stampRecords(${searchString}){
      totalCount
      maxStampQuantity
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node ${STAMP_RECORDS_NODE}
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getStampRecord = (id) => {
  const query = `{
    stampRecord(id: "${id}") ${STAMP_RECORDS_NODE}
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};
